import { useState } from "react";
import { Alert, Button, Code, NumberInput, Stack, Text, TextInput } from "@mantine/core";
import { usePostAppadminProjectsManualMutation } from "../../../../openapi";

export const AddProjectToMcApps = () => {
  const [projectNo, setProjectNo] = useState<number | string>("");
  const [projectName, setProjectName] = useState("");
  const [createProject, { data, error, isLoading }] = usePostAppadminProjectsManualMutation();
  const valid =
    typeof projectNo === "number" &&
    Number.isSafeInteger(projectNo) &&
    projectNo > 0 &&
    projectName.trim().length > 0 &&
    projectName.trim().length <= 300;
  const errorMessage =
    (error as { data?: { message?: string } })?.data?.message ?? "Kunne ikke opprette prosjektet. Prøv igjen.";

  const save = async () => {
    if (!valid || isLoading) return;
    try {
      await createProject({ body: { projectNo: projectNo as number, name: projectName.trim() } }).unwrap();
      setProjectNo("");
      setProjectName("");
    } catch {
      // The mutation error is displayed below and the form is kept for correction.
    }
  };

  return (
    <Stack gap="sm">
      <Text size="sm" c="dimmed">
        Opprett et prosjekt manuelt uten krav om tilgang i Maconomy. Du blir administrator. Medlemmer kan legges
        til manuelt. Prosjektet synkes som vanlig når det blir tilgjengelig i Maconomy.
      </Text>
      <NumberInput
        label="Prosjektnummer"
        description="Et unikt nummer i MCApps, også for frittstående prosjekter."
        value={projectNo}
        onChange={setProjectNo}
        min={1}
        max={Number.MAX_SAFE_INTEGER}
        allowDecimal={false}
        allowNegative={false}
        disabled={isLoading}
      />
      <TextInput
        label="Prosjektnavn"
        value={projectName}
        maxLength={300}
        onChange={(event) => setProjectName(event.currentTarget.value)}
        disabled={isLoading}
      />
      <Button color="green" onClick={save} disabled={!valid} loading={isLoading} style={{ alignSelf: "flex-start" }}>
        Opprett prosjekt
      </Button>
      {error && (
        <Alert color="red" title="Prosjektet ble ikke opprettet">
          {errorMessage}
        </Alert>
      )}
      {data && !error && (
        <Alert color="green" title="Prosjektet er opprettet">
          <Text>
            {data.projectNo} – {data.name}
          </Text>
          <Text size="sm">
            Project id: <Code>{data.projectId}</Code>
          </Text>
          <Text size="sm">Bruk denne ID-en i «Legg til bruker i prosjekt» for å legge til andre som prosjektadministratorer.</Text>
        </Alert>
      )}
    </Stack>
  );
};
